module.exports = __webpack_public_path__ + "assets/img/34.c8cfb9fb.png";